import { clearCurrentClient } from '../store/duck/clients'
import { clearCurrentPatient } from '../store/duck/patients'
import { clearCurrentAppointment } from '../store/duck/schedules'

export const clearBookingSessionState = (dispatch, appointment) => {
  dispatch(clearCurrentPatient())
  dispatch(clearCurrentClient())

  if (appointment?.id) {
    dispatch(clearCurrentAppointment())
  }
}
